module.exports = "class Example extends Component {\n  componentDidUpdate (prevProps, prevState) {\n    if (this.props.sortOrder !== prevProps.sortOrder) {\n      this._grid.forceUpdate()\n    }\n  }\n\n  render () {\n    return (\n      <Grid\n        {...this.props}\n        ref={(ref) => this._grid = ref}\n      />\n    )\n  }\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/force-update.js
 ** module id = 368
 ** module chunks = 0
 **/